<ng-template #backgroundTemplate>
  <div class="background">
    <div class="background-content">
      <img
        class="marker"
        alt=""
        src="https://infodata-group.eu/wp-content/uploads/2025/05/ao-vehicule.png"
      />

      <img
        alt="Integrix® ALWAYS-ON"
        src="https://infodata-group.eu/wp-content/uploads/2024/12/Logo-AO-Suivi-materiel-e1740995976124.png"
        style="width: 200px; height: auto"
      />

      <h1>Integrix® ALWAYS-ON</h1>

      <h2>LOCALISATION EN TEMPS RÉEL, trajets et pointage</h2>

      <div class="button" (click)="onBackgroundClick()">EN SAVOIR +</div>

      <div class="cards">
        <div class="card" (click)="onBackgroundClick()">
          <img
            alt=""
            src="https://infodata-group.eu/wp-content/uploads/2025/04/ao-gestion-flotte.png"
          />
          <p># GESTION DE FLOTTE</p>
        </div>
        <div class="card" (click)="onBackgroundClick('materiel')">
          <img
            alt=""
            src="https://infodata-group.eu/wp-content/uploads/2025/04/ao-suivi-materiel.png"
          />
          <p># SUIVI DE MATÉRIEL</p>
        </div>
        <div class="card" (click)="onBackgroundClick()">
          <img
            alt=""
            src="https://infodata-group.eu/wp-content/uploads/2025/04/ao-tachygraphe.png"
          />
          <p># TACHYGRAPHES</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<inf-page-login [backgroundTemplate]="backgroundTemplate" />
